export const MOBILE_CAPTURE_WIDTH = 1280;
export const MOBILE_CAPTURE_HEIGHT = 720;
export const DESKTOP_CAPTURE_WIDTH = 1920;
export const DESKTOP_CAPTURE_HEIGHT = 1080;
export const MOBILE_VIDEO_BITS_PER_SECOND = 1_500_000;
export const MOBILE_TOTAL_BITS_PER_SECOND = 1_700_000;
/** Chrome's default 1080p rate came to ~20 MB a minute. This keeps a 40-minute talk near 600 MB. */
export const DESKTOP_VIDEO_BITS_PER_SECOND = 2_000_000;
export const DESKTOP_TOTAL_BITS_PER_SECOND = 2_128_000;

export function isMobileCaptureViewport(width: number = getScreenWidth()): boolean {
  return Number(width) > 0 && Number(width) <= 700;
}

export function storyVideoConstraints(
  deviceId?: string,
  screenWidth: number = getScreenWidth(),
): MediaTrackConstraints {
  const mobile = isMobileCaptureViewport(screenWidth);
  const constraints: MediaTrackConstraints = {
    width: { ideal: mobile ? MOBILE_CAPTURE_WIDTH : DESKTOP_CAPTURE_WIDTH },
    height: { ideal: mobile ? MOBILE_CAPTURE_HEIGHT : DESKTOP_CAPTURE_HEIGHT },
    frameRate: mobile ? { ideal: 24, max: 30 } : { ideal: 30 },
  };
  if (deviceId) {
    constraints.deviceId = deviceId;
  }
  return constraints;
}

export function recordRtcStoryOptions(
  screenWidth: number = getScreenWidth(),
): {
  type: "video";
  videoBitsPerSecond?: number;
  bitsPerSecond?: number;
} {
  const mobile = isMobileCaptureViewport(screenWidth);
  return {
    type: "video",
    videoBitsPerSecond: mobile ? MOBILE_VIDEO_BITS_PER_SECOND : DESKTOP_VIDEO_BITS_PER_SECOND,
    bitsPerSecond: mobile ? MOBILE_TOTAL_BITS_PER_SECOND : DESKTOP_TOTAL_BITS_PER_SECOND,
  };
}

function getScreenWidth(): number {
  if (typeof window === "undefined" || !window.screen) {
    return 1024;
  }
  return window.screen.width;
}
